<template>
  <el-container class="myContainer">
    <el-aside width="320px" class="myContainer">
      <el-card class="box-card">
        <el-tree :data="helpCatalogData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false" class="myTree">

        </el-tree>
      </el-card>
    </el-aside>

    <el-main class="myContainer">
      <div style="height: 100%;width: 100%;display: flex;flex-direction: row">
        <PdfView :url="currentUrl" style="width:100%;height: 100%"></PdfView>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {Refresh} from '@element-plus/icons-vue'
import PdfView from "@/views/applications/oa/PdfView.vue";
export default {
  name: "HelpCatalogShow",
  components: {PdfView, Refresh},
  data() {
    return {
      helpCatalogData: [],
      currentHelpCatalogData: {},
      currentFile: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentUrl:''
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.loadHelpCatalogTree();
        }
      }
    }
  },
  methods: {
    //--勾选--
    //操作方式
    nodeClickHandle(currentRow) {
      this.currentHelpCatalogData = currentRow;
      this.loadHelpCatalogFile(this.currentHelpCatalogData.file_id);
    },
    //获取目录
    async loadHelpCatalogTree() {
      let params = {is_show:'true'};
      this.helpCatalogData = await this.$http('helpCatalogService.getRootTree',params);
    },
    //获取文件目录
    async loadHelpCatalogFile(fileId) {
      if(fileId ===undefined){
        this.currentUrl = '';
        return;
      }
      let params = {fileId:fileId};
      this.currentFile = await this.$http('helpCatalogService.getHelpFile',params);
      console.log(this.currentFile.path_in_store);
      let path = this.currentFile.path_in_store.split('\\').join('/');
      let baseUrl = this.currentFile.baseUrl;
      //this.currentUrl = encodeURIComponent(this.currentFile.path_in_store);
      //this.currentUrl = encodeURIComponent('/filetest/框架手册.pdf');
      this.currentUrl = encodeURIComponent(baseUrl+'/'+path);
    }
  },
  created() {
    this.loadHelpCatalogTree();
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.myTree {
  margin-left: -20px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }
}
</style>